import { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ExpenseCashsDetailPayments from "./ExpenseCashsDetailPayments";
import { ExpenseCashsDetailFooter } from "./ExpenseCashsDetailFooter";
import { NewDocumentModalViewContext } from "src/components/Shared/NewDocumentModalView";
import { ExpenseCashsModel } from "../models/ExpenseCashsModel";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFTab } from "src/components/Shared/NewForms/NFTab";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import { NFLookupInput } from "src/components/Shared/NewForms/NFLookupInput";
import { EnumHelper } from "src/helpers/EnumHelper";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";
import { NFLookupCashRegister } from "src/components/Shared/NewForms/NFLookupCashRegister";
import { NFLookupPaymentRequests } from "src/components/Shared/NewForms/NFLookupPaymentRequests";
import ExpenseCashsPaymentToVendorDetail from "../OperationTypesDetailsViews/ExpenseCashsPaymentToVendorDetail";
import ExpenseCashsPaymentToAdvanceHolderDetail from "../OperationTypesDetailsViews/ExpenseCashsPaymentToAdvanceHolderDetail";
import ExpenseCashsPayrollPaymentDetail from "../OperationTypesDetailsViews/ExpenseCashsPayrollPaymentDetail";
import ExpenseCashsCashDepositToBankDetail from "../OperationTypesDetailsViews/ExpenseCashsCashDepositToBankDetail";
import ExpenseCashsIssueToAnotherBankDetail from "../OperationTypesDetailsViews/ExpenseCashsIssueToAnotherBankDetail";
import ExpenseCashsPaymentForOptainedDetail from "../OperationTypesDetailsViews/ExpenseCashsPaymentForOptainedDetail";
import ExpenseCashsLoanToEmployeeDetail from "../OperationTypesDetailsViews/ExpenseCashsLoanToEmployeeDetail";
import ExpenseCashsLoanToCounterPartyDetail from "../OperationTypesDetailsViews/ExpenseCashsLoanToCounterPartyDetail";
import ExpenseCashsCurrencyConversionDetail from "../OperationTypesDetailsViews/ExpenseCashsCurrencyConversionDetail";
import ExpenseCashsOtherExpensesDetail from "../OperationTypesDetailsViews/ExpenseCashsOtherExpensesDetail";
import ExpenseCashsRefundToCustomerDetail from "../OperationTypesDetailsViews/ExpenseCashsRefundToCustomerDetail";
import { NFLookupBaseDocuments } from "src/components/Shared/NewForms/NFLookupBaseDocuments";
import { NFLookupCashflowItem } from "src/components/Shared/NewForms/NFLookupCashflowItem";
import { useFetchExpenseCash } from "../hooks/fetchDocument";

interface IProps {
  id?:string
}

export const ExpenseCashsDetail = ({id}: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ExpenseCashsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  // const watchProducts = watch("postingOfGoodGoods");
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Expense Cashs");
  const { t } = useTranslation();
  const [selectedOpType, setSelectedOpType] = useState(0);

  const handleTypeChange = (value: any) => {
    setSelectedOpType(value);
  };
  const operationType = watch("operationType");
  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchExpenseCash({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };
  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.ExpenseCashPayments.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Additional"} />
        <NFTab title={"Payments"} />
      </NFTabs>

      <div className={"modal-container-height"}>
     
         {/* <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar> */}
          <DocumentDetailViewToolbar>
        <DetailViewPostButton onPost={handlePost} />
        <DetailViewCancelButton onCancel={handleCancel} />
      </DocumentDetailViewToolbar>
        <Row>
          <Col sm={6}>
            <NFLookupInput title={"Operation type"} fieldName={"operationType"} items={EnumHelper.GetOutgoingCashPaymentType()} onValueChange={handleTypeChange} />
          </Col>
          <Col sm={6}>
            <NFLookupInput title={t("Status")} fieldName={"status"} items={EnumHelper.GetPaymentRequestsStatus()} required />
          </Col>
        </Row>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} required />
            </Col>
            <Col sm={6}>
              <NFDateInput title={t("ProcessedDate")} fieldName="processedDate" />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={t("Document#")} disabled fieldName={"documentNumber"} />
            </Col>
            <Col sm={6}>
              <NFLookupCompany fieldName="companyId" title={t("Company")} required />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFDateInput title={t("PaymentDate")} fieldName={"paymentDate"} required />
            </Col>
            <Col sm={6}>
              <NFLookupCurrency title={t("Currency")} fieldName={"currencyId"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupInput title={t("AsAListNoSplit")} fieldName={"operationType"} items={EnumHelper.GetOutgoingBankCashListSplitTypeEnum()} />
            </Col>
            <Col sm={6}>
              <NFLookupDivision fieldName="divisionId" title={t("Division")} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupCashRegister fieldName="cashRegisterId" title={t("CashRegister")} />
            </Col>
            <Col sm={6}>
              <NFLookupPaymentRequests fieldName="paymentRequestId" title={t("PaymentRequests")} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={t("Amount")} fieldName={"amount"} />
            </Col>
          </Row>

          {operationType === 0 && <ExpenseCashsPaymentToVendorDetail />}
          {operationType === 1 && <ExpenseCashsPaymentToAdvanceHolderDetail />}
          {operationType === 2 && <ExpenseCashsPayrollPaymentDetail />}
          {operationType === 3 && <ExpenseCashsCashDepositToBankDetail />}
          {operationType === 4 && <ExpenseCashsIssueToAnotherBankDetail />}
          {operationType === 5 && <ExpenseCashsPaymentForOptainedDetail />}
          {operationType === 6 && <ExpenseCashsLoanToEmployeeDetail />}
          {operationType === 7 && <ExpenseCashsLoanToCounterPartyDetail />}
          {operationType === 8 && <ExpenseCashsCurrencyConversionDetail />}
          {operationType === 9 && <ExpenseCashsOtherExpensesDetail />}
          {operationType === 10 && <ExpenseCashsRefundToCustomerDetail />}
        </NFTabContainer>
        <NFTabContainer index={1} currentIndex={tabIndex}>
          <Row>
            <Col md={6}>
              <NFLookupBaseDocuments title={t("BaseDocument")} fieldName="baseDocumentAtId" />
            </Col>
            <Col md={6}>
              <NFLookupCashflowItem fieldName="cashFlowItemId" title={t("CashFlowItem")} required />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <NFTextInput title={t("CreatedUser")} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col md={6}>
              <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} required />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <NFTextInput fieldName="comment" title={t("Comment")} />
            </Col>
          </Row>
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <ExpenseCashsDetailPayments />
        </NFTabContainer>
        {/* )} */}
      </div>
      <ExpenseCashsDetailFooter />
    </FormProvider>
  );
};
